// exportar funcion ArmarRoutes de utils rutas para usarla al importar
// este paquete
import armarRoutes from "./utils/routes";

export default {
  armarRoutes
};
